import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

const DocumentModal = ({ label, videoUrl }) => {
    const [isOpen, setIsOpen] = useState(false)
    const [top, setTop] = useState('0')

    const openModal = () => {
        if (!window) return

        setTop(`${window.pageXOffset + 40}px`)
        setIsOpen(true)
    }

    const closeModal = () => {
        setIsOpen(false)
    }

    const renderModal = () => {
        if (!isOpen) return ''

        return ReactDOM.createPortal(
            <>
                <div id="modal-cover"></div>
                <div
                    id="modal-video"
                    className="modal document-modal modal-fixed"
                    // style={{ top: top }}
                >
                    {videoUrl && videoUrl.includes('.pdf') && (
                        <a
                            href={videoUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            download
                            className="document-modal-button-download"
                        >
                            Download eBook
                        </a>
                    )}
                    <div className="embed-container">
                        <iframe
                            src={videoUrl}
                            frameBorder={0}
                            allowFullScreen={true}
                            height="100%"
                            width="100%"
                            // width="640"
                            // height="360"
                        ></iframe>
                    </div>
                    <button onMouseDown={closeModal} className="document-modal-button">
                        CLOSE
                    </button>
                </div>
            </>,
            document.body
        )
    }

    return (
        <>
            {/* <button onMouseDown={openModal} className="btn btn-arrow-white">
                {label}
            </button> */}
            <a onMouseDown={openModal} className="more-link">
                {label ?? 'Download'}
            </a>
            {renderModal()}
        </>
    )
}

export default DocumentModal
